import React, { Component } from "react";


import BootstrapTable from "react-bootstrap-table-next";

import Modal from "react-responsive-modal";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Badge
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Dropzone from "react-dropzone";
import Resizer from "react-image-file-resizer";
import axios from "axios";

import Select from "react-select";
import NumberFormat from 'react-number-format';
import { numberSeparator } from '../function/Format';


// koneksi
import { Post, Get, Delete, JENIS_DESA } from "../function/Koneksi";
import { DataToken } from "../function/Format";

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "../assets/css/content-styles.css"

// import CKEditors from "react-ckeditor-component";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import ReactSelect from "react-select";
var HtmlToReactParser = require("html-to-react").Parser;



const frmDef = {
  uuid: "",
  nama_dokumen: "",
  link_dokumen: "",
};
// const jenis = ['Pelaksanaan','Pendapatan','Pembelanjaan'];

// function MyCustomUploadAdapterPlugin(editor) {
//   editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
//     // Configure the URL to the upload script in your back-end here!
//     return new BasicTable(loader);
//   };
// }

class BasicTable extends Component {
  constructor(props) {
    super(props);
    this.loader = props
    this.state = {
      data: [],
      pagination: [],
      status: {
        form: false,
        btnForm: false,
        btnAksi: false,
        modalDetail: false,
      },
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",
      dt: frmDef,
      judul: "Tambah Info PPID",
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      konten: false,
      content: "",
      token: DataToken(sessionStorage.getItem("access_token")),
      foto_desa: "",
      link_gambar: "",
      formDisposisi: false,
      stpStat: { label: '', value: '' },
      ckimage_resp: null,
      loading: false,
      jenis: null,
      //pencarian
      dataCari: {
        q: '',
      }
    };
    this.onChange = this.onChange.bind(this);
    this.updateContent = this.updateContent.bind(this);
    this.onChange = this.onChange.bind(this);
    this.afterPaste = this.afterPaste.bind(this);
  }

  // =========== CKEDITOR 5 =============
  upload() {
    return new Promise((resolve, reject) => {

      const data = new FormData();
      // console.log(data)

      this.loader.file.then(result => {
        data.append('files[]', result);
        // this.xhr.send(data);

        const url = process.env.REACT_APP_API_URL2;

        axios.post(url + "upload-file-multiple/galery", data).then(res => {
          // console.log(res)

          if (res.data.results) {
            // console.log("HAHA Gambarnya adalah")
            // console.log(res.data.results[0])

            const xhr = res.data;
            const loader = this.loader;
            const genericErrorText = 'Couldn\'t upload file:' + ` ${loader.file.name}.`;

            // xhr.code('404', () => reject(genericErrorText));
            // xhr.addEventListener('abort', () => reject());
            const response = xhr.code;

            if (response == 200) {
              resolve({
                default: xhr.results[0]
              });
            } else {
              reject()
            }

            // if (response != 200) {
            //   reject(genericErrorText)
            // }
            // else if (this.state.ckimage_resp && this.state.ckimage_resp.message == 'Hapus') {
            //   reject()
            // }
            // else if (!response || response != 200) {
            //   return reject(response && response != 200 ? response.error.message : genericErrorText);
            // }
            // // If the upload is successful, resolve the upload promise with an object containing
            // // at least the "default" URL, pointing to the image on the server.
            // else if (response == 200)
            //   resolve({
            //     default: xhr.results[0]
            //   });
          }
        })
      }
      )
    })
  }

  // Aborts the upload process.
  abort() {
    if (this.xhr) {
      this.xhr.abort();

      this.setState({
        ckimage_resp: { code: '406', message: 'Hapus' }
      });
    }
  }

  handleCKEditor = (event, editor) => {
    const data = editor.getData();
    // console.log("DATA KONTEN")
    // console.log(data)

    this.setState({
      konten: data
    })
  }

  createMarkup = () => {
    return { __html: this.state.content };
  }

  // =========== END CKEDITOR 5 =============

  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetch = (params = {}) => {
    this.setState({ loading: true })
    let link = "";
    // let where = [];
    // if (params.where) {
    //   where = params.where;
    // }
    if (params.page) {
      switch (params.page) {
        case ">>":
          link =
            "?page=" +
            Math.ceil(
              this.state.pagination.total / this.state.pagination.per_page
            );
          break;
        case ">":
          link = "?page=" + (parseInt(this.state.pagination.current_page) + 1);
          break;
        case "<":
          link = "?page=" + (parseInt(this.state.pagination.current_page) - 1);
          break;
        case "<<":
          link = "?page=1";
          break;
        default:
          link = "?page=" + params.page;
          break;
      }
    }
    let setLink = '';
		if (link) {
			setLink = `${link}&q=${this.state.dataCari.q}`
		}
		else {
			setLink = `?q=${this.state.dataCari.q}`
		}

		Get('info-ppid' + setLink, null, (dtkat) => {
			console.log('Data Result')
			console.log(dtkat)
			this.setState({ data: dtkat.results.data, pagination: dtkat.results, loading: false });
			this.pagination(dtkat.results);
		});
  };

  // Pagination
  pagination = data => {
    // const data = this.state.pagination;
    let awal = "";
    let hal = [];
    let sebelum = "";
    let setelah = "";
    let akhir = "";
    if (data.total > 0) {
      let start = 1;
      let end = 5;
      let n = 0;
      let p = 0;
      if (data.current_page <= 3) {
        start = 1;
        end = 5;
        if (data.last_page > data.current_page) {
          n = data.current_page + 1;
        }
      } else {
        p = data.current_page - 1;
        n = data.current_page + 1;
        start = data.current_page - 2;
        end = data.current_page + 2;
      }
      if (end >= data.last_page - 2) {
        p = data.current_page - 1;
        if (start >= 5) {
          start = data.last_page - 4;
        }
        end = data.last_page;
      }

      for (let i = start; i <= end; i++) {
        let warna = "primary-custom";
        if (i === data.current_page) {
          warna = "danger";
        }
        hal.push(
          <a
            href={() => false}
            onClick={() => this.fetch({ page: i })}
            className={
              "btn btn-" + warna + " btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
            }
          >
            {i}
          </a>
        );
      }
      if (p > 0) {
        sebelum = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: p })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {"<"}
          </a>
        );
      }
      if (n > 0) {
        setelah = (
          <a
            href={() => false}
            onClick={() => this.fetch({ page: n })}
            className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
          >
            {">"}
          </a>
        );
      }
      awal = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: 1 })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {"<<"}
        </a>
      );
      akhir = (
        <a
          href={() => false}
          onClick={() => this.fetch({ page: data.last_page })}
          className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2"
        >
          {">>"}
        </a>
      );
    }
    this.setState({ awal, sebelum, hal, setelah, akhir });
  };
  // Cari Data Table
  cariData = e => {
    if (e.key === 'Enter') {
			let dataCari = {
				q: e.target.value
			};
			this.setState({ dataCari });
			setTimeout(
				function () {
					// mywindow.close();
					this.fetch();
				}.bind(this),
				500
			);
    };
  };

  // ========================================================================

  // ubah select value
  changeSelectValue = (e, sel) => {
    // if (e) {
    //   switch (sel) {
    //     case "jenis-info":
    //       if (e.value === "info") {
    //         this.state.konten = true;
    //       } else {
    //         this.state.konten = false;
    //       }
    //       this.setState({
    //         stpStat: e,
    //         dt: { ...this.state.dt, jenis: e.value }
    //       });
    //       break;
    //     default:
    //       // no default
    //       break;
    //   }
    // } else {
    //   switch (sel) {
    //     case "jenis-info":
    //       this.state.dt.status_penduduk = 0;
    //       this.setState({ stpStat: e });
    //       break;
    //     default:
    //       // no default
    //       break;
    //   }
    switch (sel) {
      case "jenis":
        this.setState({ jenisStat: e });
        break;
            
      default:
        break;
    }

    this.state.status.select = false;
    this.forceUpdate();
  };
  /// upload file

  processGbr = d => {
    if (d.length === 1) {
      let type = d[0].type.split("/");
      if (
        type[1] === "jpg" ||
        type[1] === "jpeg" ||
        type[1] === "png" ||
        type[1] === "bmp" ||
        type[1] === "tiff" ||
        type[1] === "webp"
      ) {
        let bodyFormData = new FormData();
        bodyFormData.append("files", d[0]);

        Post("upload-file/berita", null, bodyFormData, data => {
          Resizer.imageFileResizer(
            d[0],
            300,
            300,
            type[1],
            100,
            0,
            uri => {
              this.setState({
                foto_desa: uri,
                foto_info: "",
                link_gambar: data.data.results
              });
            },
            "base64"
          );
        });

      } else {
        this.setState({
          foto_desa: "",
          foto_info: (
            <div className="text-danger font-size-10">
              Type file tidak valid
            </div>
          )
        });
      }
    } else {
      this.setState({
        foto_desa: "",
        foto_info: (
          <div className="text-danger font-size-10">
            Silahkan masukan satu gambar
          </div>
        )
      });
    }
  };

  uploadFiles() {
		return Promise.all(this.state.dt.dataDokumen.map((obj, i) => {
			const selectedFile = document.getElementById('file-upload' + (i + 1)).files[0]
      const fileType = selectedFile.name.split('.')
      const type = fileType[1]
      const name = obj.nama

			let formData = new FormData()
			formData.append("files", selectedFile)

			return this.postImage(formData, type, name)
		}))
			.then((results) => {
				return results
			})
			.catch((err) => {
				return []
			})
	}

  async postImage(formData, type, nama) {
    let folder = 'img'
    if (type === "pdf") {
      folder = "pdf"
    }
    else if (type === "xls" || type === "xlsx" || type === "csv") {
      folder = "excel"
    }
    else if (type === "doc" || type === "docx") {
      folder = "doc"
    }

		let datatable = await axios.post(`${localStorage.getItem('SET_API_URL') + 'upload-file/' + folder}`, formData, {
			headers: { Authorization: `Bearer ${sessionStorage.getItem("access_token")}` },
			validateStatus: false
		});
    
		return {
      nama,
      link: datatable,
      ext: type,
    }
	}

  // ================== simpan data ==================
  simpan = e => {
    e.preventDefault();

		this.setState({ loadingPreview: true });

      if(this.state.jenis){
        let bodyData = {
          jenis : this.state.jenis.value,
          nama_dokumen : document.getElementById("nama_dokumen").value,
          link_dokumen : document.getElementById("link_dokumen").value,
          uuid: document.getElementById("uuid").value,
        }
      
        let psn = "";
        let resstat = 204;
        let metode = "create";
        if (bodyData.uuid === "") {
          psn = "tambah";
          resstat = 201;
          bodyData.uuid = null;
        } else {
          psn = "ubah";
          resstat = 200;
          metode = "update";
        }
  
        Post('info-ppid/' + metode, bodyData.uuid, bodyData, res => {
          if (res.status === resstat) {
            this.setState({
              loadingPreview: false,
              show: true,
              basicType: "success",
              basicTitle: "Data Info PPID "+JENIS_DESA,
              pesanAlert: "Berhasil " + psn + " Data",
              dt: frmDef,
              status: {
                ...this.state.status,
                form: false
              }
            });
          } else {
            this.setState({
              loadingPreview: false,
              show: true,
              basicType: "danger",
              basicTitle: "Data Info PPID "+JENIS_DESA,
              pesanAlert: "Gagal " + psn + " Data"
            });
          }
  
          this.componentDidMount();
        })
      }
      else{
        this.setState({
          loadingPreview: false,
          show: true,
          basicType: "danger",
          basicTitle: "Data Info PPID "+JENIS_DESA,
          pesanAlert: "Data Harus Lengkap!"
        });
      }

  };
  // ========================================================================
  // list disposisi

  detailBerita = data => {
    let dataDokumen = this.state.dt.dataDokumen
    if (data.link_dokumen) {
      dataDokumen = JSON.parse(data.link_dokumen)
    }

    this.setState({
      formDisposisi: true,
      content: data.konten,
      link_gambar: data.link_gambar,
      dt: {
        ...this.state.dt,
        judul: data.judul,
        keyword: data.keyword,
        dataDokumen,
      }
    });
  };
  // ============================== Ubah Data ===============================
  ubahData = id => {
		this.setState({
			judul: "Ubah Data Info PPID "+JENIS_DESA,
			editMode: true
		})

    if (id) {
			this.setState({
				dt: {
					jenis : id.jenis,
					nama_dokumen : id.nama_dokumen,
					link_dokumen : id.link_dokumen,
					uuid: id.uuid,
				},	
				jenis: {
					value: id.jenis, label: (
						id.jenis == 'Desa' ? 'Desa'
						: id.jenis == 'Kecamatan' ? 'Kecamatan'
							: 'Kabupaten'
					)
				},
				status: {
					...this.state.status,
					form: true
				}
			})
		}
  };
  // ========================================================================
  // ============================= Hapus Data ===============================
  konfirmHapus = id => {
    this.setState({
      alert: (
        <SweetAlert
          showCancel
          confirmBtnText="Hapus"
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="success"
          type="danger"
          title="Yakin ingin hapus data ?"
          onCancel={this.hideAlert}
          onConfirm={() => this.hapusData(id)}
        >
          Proses ini tidak dapat dibatalkan!
        </SweetAlert>
      )
    });
  };

  hapusData = id => {
    this.hideAlert();
    let psn = "Hapus";
    Delete("info-ppid/delete", id, res => {
      if (res === 200) {
        this.setState({
          show: true,
          basicType: "success",
          basicTitle: "Data Info PPID " + JENIS_DESA,
          pesanAlert: "Berhasil " + psn + " Data"
        });
      } else {
        this.setState({
          show: true,
          basicType: "danger",
          basicTitle: "Data Info PPID " + JENIS_DESA,
          pesanAlert: "Gagal " + psn + " Data"
        });
      }
      this.componentDidMount();
    });
  };
  // ========================================================================

  bukaForm = () => {
    this.setState({
			status: {
				...this.state.status,
				form: true,
			},
		})
		this.forceUpdate();
  };

  tutupForm = () => {
    this.setState({
			status: {
				...this.state.status,
				form: false,
			},
		})

		this.forceUpdate();
  };

  tombolDownload = (cell, row) => {
    return (
        <>
            <Button  size="md" color="success" className="btn-icon" onClick={() => window.open(row.link_dokumen, "_blank")}><i className="fa fa-download"></i> Unduh</Button> 
        </>
    )
}

  tombolAksi = (cell, row) => {
    return (
      <div>
        <Button
          size="xs"
          color="success"
          className="btn-icon mr-1"
          onClick={() => this.ubahData(row)}
          disabled={this.state.status.btnAksi}
        >
          <i className="fa fa-pencil"></i>
        </Button>
        <Button
          size="xs"
          color="danger"
          className="btn-icon mr-1"
          onClick={() => this.konfirmHapus(row.uuid)}
          disabled={this.state.status.btnAksi}
        >
          <i className="fa fa-trash"></i>
        </Button>
      </div>
    );
  };
  componentDidMount() {
    this.fetch({ page: null, where: [] });

    Get("select-enum/info_desa/jenis", null, data => {
      let frmStp = [];
      data.forEach(dt => {
        let label = dt == 'info' ? 'berita' : dt
        frmStp.push({ value: dt, label });
      });
      this.setState({ frmStp });
    });
  }

  //ck editor

  updateContent(newContent) {
    this.setState({
      content: newContent
    });
  }

  onChange(evt) {
    var newContent = evt.editor.getData();
    this.setState({
      content: newContent
    });
  }

  onBlur(evt) {
    //console.log("onBlur event called with event info: ", evt);
  }

  afterPaste(evt) {
    //console.log("afterPaste event called with event info: ", evt);
  }

  // // ==================== Upload File =====================
  // onFileChange = (event, i) => {
  //   const file = event.target.files[0];
  //   // const fileType = file.type.split('/')
  //   // const type = fileType[1]
  //   const fileType = file.name.split('.')
  //   const type = fileType[1]

  //   // console.log('Upload File')
  //   // console.log(file)

  //   // Disable tombol selesai sampai file berhasil diupload
  //   this.setState({
  //     status: {
  //       ...this.state.status,
  //       btnForm: true
  //     }
  //   })

  //   if (type === "pdf" || type === "jpg" || type === "jpeg" || type === "png" || type === "xls" || type === "xlsx" || type === "csv" || type === "doc" || type === "docx") {
  //     let bodyFormData = new FormData();
  //     bodyFormData.append("files", file);

  //     let folder = 'img'
  //     if (type === "pdf") {
  //       folder = "pdf"
  //     }
  //     else if (type === "xls" || type === "xlsx" || type === "csv") {
  //       folder = "excel"
  //     }
  //     else if (type === "doc" || type === "docx") {
  //       folder = "doc"
  //     }

  //     Post("upload-file/" + folder, null, bodyFormData, (response) => {
  //       if (response.status === 200) {

  //         const link = response.data.results

  //         let ext = type
  //         let dataDokumen = [...this.state.dt.dataDokumen]
  //         dataDokumen[i] = { ...dataDokumen[i], link, ext }

  //         this.setState({
  //           dt: {
  //             ...this.state.dt,
  //             dataDokumen
  //           },
  //           status: {
  //             ...this.state.status,
  //             btnForm: false
  //           }
  //         })
  //       }
  //       else {
  //         let link = ''
  //         let ext = ''
  //         let dataDokumen = [...this.state.dt.dataDokumen]
  //         dataDokumen[i] = { ...dataDokumen[i], link, ext }

  //         this.setState({
  //           show: true,
  //           basicType: "danger",
  //           basicTitle: "Upload file",
  //           pesanAlert: "Gagal Upload File",
  //           dt: {
  //             ...this.state.dt,
  //             dataDokumen
  //           },
  //           status: {
  //             ...this.state.status,
  //             btnForm: false
  //           }
  //         });
  //       }
  //     });
  //   } else {
  //     this.setState({
  //       show: true,
  //       basicType: "warning",
  //       basicTitle: "Upload file",
  //       pesanAlert: "Format file harus berupa jpg/jpeg/png/pdf/xls/csv/doc",
  //       status: {
  //         ...this.state.status,
  //         btnForm: false
  //       }
  //     });
  //     document.getElementById("file-upload").value = null
  //   }
  // };

  // keywordsView = () => {
  //   if (this.state.dt.keyword) {
  //     let keywords = this.state.dt.keyword
  //     keywords = keywords.split(',')
  //     console.log(keywords);
  
  //     let cleanKeywords = []
  //     if (keywords.length > 0) {
  //       keywords.map((e, idx) => {
  //         cleanKeywords[idx] = e.trim()
  //       })
  
  //       return (
  //         <div className="mt-4">
  //           <span>Kata kunci : </span>
  //           {cleanKeywords.map((f) => {
  //             return (
  //               <Badge color="info">{f}</Badge>
  //             )
  //           })}
  //         </div>
  //       )
  //     }
  //   } else {
  //     return (
  //       <div className="mt-4">
  //         <span>Kata kunci : -</span>
  //       </div>
  //     )
  //   }
    
  // }

  render() {

    var data = this.state.data;

    const columns = [
      {
				dataField: "no",
				text: "No",
				isDummyField: true,
				csvExport: false,
				headerAlign: 'center',
				align: 'center',
				formatter: (key, obj, index) => {
					let current_pagenum = this.state.pagination.current_page;
					let total_records_per_page = this.state.pagination.per_page;
					let row_index = (index + 1);
					let serial_num = ((total_records_per_page * (current_pagenum - 1)) + row_index);
					return serial_num;
				}
			},
      {
        dataField: "nama_dokumen",
        headerAlign: 'center',
        align: 'center',
        text: "Nama Dokumen",
        sort: false
      },
      {
        dataField: "link_dokumen",
        headerAlign: 'center',
        align: 'center',
        text: "Link Dokumen",
        formatter: this.tombolDownload
      },
      {
        dataField: "jenis",
        headerAlign: 'center',
        align: 'center',
        text: 'Jenis PPID '+ JENIS_DESA,
        sort: false
      },
      {
        dataField: "aksi",
        headerAlign: 'center',
        align: 'center',
        text: "Aksi",
        style: {
          width: '130px'
        },
        formatter: this.tombolAksi
      }
    ];

    return (
      <div>
        {/* <Breadcrumb title="Data Info Desa" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card mb-0">
                <div className="card-header">
                  <div className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        className="form-control"
                        id="cariTable"
                        placeholder="Cari Data berdasarkan nama dokumen PPID"
                        onKeyPress={this.cariData}
                      />
                    </div>
                    <div className="col-sm-6 text-right">
                      <Button
                        size="sm"
                        color="success"
                        className="btn-square"
                        onClick={() => {
                          this.setState({
                            judul: "Tambah Info PPID " + JENIS_DESA,
                            dt: frmDef,
														jenis: null,
                          });
                          this.bukaForm();
                        }}
                      >
                        Tambah Data
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="card-body datatable-react">
                  {this.state.loading ? (
                    <div className="row">
                      <div className="col-sm-12" align="center">
                        <img
                          alt="loading"
                          src={require("../assets/images/tes-loading.gif")}
                          style={{
                            borderRadius: "10px",
                            width: '100px'
                          }} />
                      </div>
                    </div>
                  ) : data.length !== 0 ? (
                    <>
                      <BootstrapTable keyField="id" data={data} columns={columns} />
                      <div className="pull-right text-white">
                        {this.state.awal}
                        {this.state.sebelum}
                        {this.state.hal.map(dt => {
                          return dt;
                        })}
                        {this.state.setelah}
                        {this.state.akhir}
                      </div>
                    </>
                  ) : (
                    <h6 className="text-center mb-2 mt-2">Belum ada data</h6>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <Modal
          open={this.state.status.form}
          onClose={this.tutupForm}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          styles={{ modal: { width: "65%", maxWidth: 'unset' } }}
        >
          <Form className="theme-form" onSubmit={this.simpan}>
            <div className="modal-header">
              <h5 className="modal-title">{this.state.judul}</h5>
            </div>
            <div className="modal-body">
              <input
                className="form-control" id="uuid" type="hidden"placeholder="uuid" defaultValue={this.state.dt.uuid} value={this.state.dt.uuid}
              />
              <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Nama Dokumen
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="nama_dokumen"
                      type="text"
                      placeholder="Nama Dokumen"
                      defaultValue={this.state.dt.nama_dokumen}
                      onChange={(e) => {
                        this.setState({
                          dt: {
                            ...this.state.dt,
                            nama_dokumen: e.target.value
                          }
                        })
                      }}
                      required
                    />
                  </Col>
                </FormGroup>
                <FormGroup className="row">
                  <Label
                    className="col-sm-3 col-form-label"
                    htmlFor="inputEmail3"
                  >
                    Link Dokumen
                  </Label>
                  <Col sm="9">
                    <input
                      className="form-control"
                      id="link_dokumen"
                      type="text"
                      placeholder="Link Dokumen"
                      defaultValue={this.state.dt.link_dokumen}
                      onChange={(e) => {
                        this.setState({
                          dt: {
                            ...this.state.dt,
                            link_dokumen: e.target.value
                          }
                        })
                      }}
                      required
                    />
                  </Col>
                </FormGroup>
              <FormGroup className="row">
                <Label
                  className="col-sm-3 col-form-label"
                  htmlFor="inputJenis"
                >
                  Jenis PPID
                </Label>
                <Col sm="9">
                  <ReactSelect
                    inputId="jenis"
                    classNamePrefix="select"
                    onChange={e => {
                      this.setState({ 
                        jenis: e
                       })
                    }}
                    defaultValue={this.state.jenis}
                    value={this.state.jenis}
                    name="jenis"
                    options={[
                      {
                        value: 'Desa',
                        label: 'Desa',
                      },
                      {
                        value: 'Kecamatan',
                        label: 'Kecamatan',
                      },
                      {
                        value: 'Kabupaten',
                        label: 'Kabupaten',
                      },
                    ]}
                    placeholder="Pilih Jenis PPID"
                  />
                </Col>
              </FormGroup>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-warning"
                disabled={this.state.status.btnForm}
                onClick={this.tutupForm}
              >
                Tutup
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={this.state.status.btnForm}
              >
                Simpan
              </button>
            </div>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default BasicTable;
